import { useParams } from 'react-router-dom';
import { ProjectDashboard } from './components/dashboard';

// ============================================================
// Main page component — delegates to ProjectDashboard
// ============================================================
export default function ProjectDetail() {
  const { appId } = useParams<{ appId: string }>();
  if (!appId) return null;
  return <ProjectDashboard appId={appId} />;
}
